export default {"src":"https://cdn.jetlend.ru/_next/static/media/department-finance.0f283f5d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};